// US Letter (landscape) packing list for Mezcla, adapted from the Biom generic packing list.
// Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const mezclaPackingListFileDataSchema = yup.object().shape({
  documentTitle: yup.string().nullable().optional(),
  partnerName: yup.string().nullable().optional(),
  poNumber: yup.string().nullable().optional(),
  shipFromName: yup.string().nullable().optional(),
  shipFromAddress: yup.string().nullable().optional(),
  shipToName: yup.string().nullable().optional(),
  shipToAddress: yup.string().nullable().optional(),
  dateShipped: yup.string().nullable().optional(),
  scheduledDeliveryAppointment: yup.string().nullable().optional(),
  broker: yup.string().nullable().optional(),
  carrier: yup.string().nullable().optional(),
  trailerNumber: yup.string().nullable().optional(),
  shipmentId: yup.string().nullable().optional(),
  bolNumber: yup.string().nullable().optional(),
  totalPallets: yup.string().nullable().optional(),
  totalGrossWeightWithPallets: yup.string().nullable().optional(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        sku: yup.string().nullable().optional(),
        partnerItem: yup.string().nullable().optional(),
        description: yup.string().nullable().optional(),
        shipped: yup.string().nullable().optional(),
        uom: yup.string().nullable().optional(),
        serialLot: yup.string().nullable().optional(),
      }),
    )
    .required(),
})

export type MezclaPackingListFileData = yup.InferType<typeof mezclaPackingListFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<MezclaPackingListFileData>

/** Each leaf is a stable GeneratedFileField UUID. */
export const mezclaPackingListFileMappings: RequiredFileData = {
  documentTitle: '7daa309b-ef17-49e5-b7de-30ba0fb8dc60',
  partnerName: '45501fee-2c56-4b71-9629-36905e1c4611',
  poNumber: '0cf3c14a-89f0-40d1-b75e-7828f8fa940b',
  shipFromName: '631b1f32-6522-4808-8976-445fabfdd4ab',
  shipFromAddress: 'e63b1bdd-0013-4984-9e2c-391651ebf7a1',
  shipToName: 'ab861a27-7729-4939-9fca-09a134921311',
  shipToAddress: '93039838-fd8c-4bc9-b36d-b2f97468f794',
  dateShipped: '33debc3c-0d7a-4067-a879-a5117a4d1be4',
  scheduledDeliveryAppointment: '5e872bfc-15e6-4d27-940f-1fb13cf16e5f',
  broker: '8750ae32-23c4-401b-9407-11381f19319d',
  carrier: '78b4560e-f5c3-4ac8-a042-28bfc9d9bdcf',
  trailerNumber: '8217cf77-3f62-479f-8789-5751e295c314',
  shipmentId: '1dcc11d5-3bbc-4330-866e-cdffbd55d770',
  bolNumber: '80c78ace-0510-4853-ba83-b5bfe384cc34',
  totalPallets: '3d3e1616-359d-42fc-a260-1f15ecfad4ef',
  totalGrossWeightWithPallets: '263bcf68-afa0-4d49-9ca4-031863e3f44a',
  items: [
    {
      sku: 'b81921e0-d8c5-442c-a157-61da0b124b5e',
      partnerItem: '42940b7a-61d3-45b8-9edb-639d0a818d0e',
      description: '5e92f68d-b5d6-4d51-bc25-2b12a71419f0',
      shipped: '87306602-b548-4f35-a401-02a599b7370c',
      uom: '2519b5ef-5e02-4114-8d90-7741cb5e428d',
      serialLot: '02e480f0-f477-45c9-aedf-73b7f49bcbac',
    },
  ],
}
